import React, { useState } from 'react'
import { Box, IconButton, Menu, MenuItem } from '@mui/material'
import { useSelector } from 'react-redux'
import CircleIcon from '@mui/icons-material/Circle';
import { useNavigate } from 'react-router-dom';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { useDispatch } from "react-redux"
import { logoutUser } from '../../../redux/slice/user';

const options = [
  'Logout',
  '다른거',
];

const ITEM_HEIGHT = 48;

const Header = () => {
  var nav = useNavigate();
  const auth = useSelector((state:any) => state.userInfo.data);
  console.log('Header page userInfo',auth)

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    // console.log('event.currentTarget',event.currentTarget)
  };
  const handleClose = (e:any) => {
    console.log('anchorEl',e.target.innerText, anchorEl)
    
    setAnchorEl(null);
    if(e.target.innerText === 'Logout')
      dispatch(logoutUser())
  };


  return (
    <Box sx={{ display: "flex", backgroundColor: "#24292f", color: "#ffffff", fontWeight : 500, height:"52px"}}>
      <Box sx={{display: "flex", marginLeft:2, cursor: "pointer"}} onClick={()=> nav('/insight/main')}>
        <Box sx={{display: "flex"}}>
          <img style={{objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/insight_logo2.png'} />
        </Box>
        <Box sx={{marginLeft:1, fontSize: "x-large", alignSelf: "center"}}>INSIGHT HUB</Box>  
      </Box>
      <Box sx={{display: "flex", fontSize: "small", alignSelf: "center", marginLeft:"auto"}}><CircleIcon sx={{alignSelf: "center", marginRight:"4px", color:"#8bc34a"}} fontSize="small"/>{auth.user.email}</Box>
      <Box sx={{display: "flex", marginRight:"80px", fontSize: "small", alignSelf: "center"}}>
        <IconButton
          sx={{color: "#fff"}}
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <GridExpandMoreIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '15ch',
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option} selected={option === 'Logout'} onClick={handleClose}>
              {option}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  )
}

export default Header